import SEO from "components/seo";
import Layout from "components/layout";
import MarketingTranslation from "components/reusableComponents/MarketTranslation/MarketingTranslation";
import React from "react";

function index() {
  const title = "Marketing Translation Services | Tomedes";
  const description =
    "Our marketing translation services help businesses and corporations reach their global objectives. We translate marketing collaterals and materials whether for print or digital media.";
  const keywords =
    "marketing translation, professional marketing translation, marketing translation quote";
  const slug = "/marketing-translation.php";
  return (
    <Layout>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        slug={slug}
      />
      <MarketingTranslation />
    </Layout>
  );
}

export default index;
